import { Component, ChangeDetectionStrategy, Input, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';

const _c0 = [[["", "before-svg", ""]], "*", [["", "after-svg", ""]]];
const _c1 = ["[before-svg]", "*", "[after-svg]"];
const _c2 = ["ngx-rect", ""];
const _c3 = ["ngx-svg-stop", ""];
const _c4 = ["ngx-facebook-preset", ""];
const _c5 = ["ngx-instagram-preset", ""];
const _c6 = ["ngx-circle", ""];
const _c7 = ["ngx-code-preset", ""];
const _c8 = ["ngx-bullet-list-preset", ""];
const _c9 = ["ngx-list-preset", ""];
var Defaults;
(function (Defaults) {
    Defaults["PrimaryColor"] = "#f3f3f3";
    Defaults["SecondaryColor"] = "#ecebeb";
    Defaults["PreserveAspectRatio"] = "xMidYMid meet";
    Defaults["Classes"] = "";
    Defaults["Speed"] = "1000ms";
    Defaults["Width"] = "400";
    Defaults["Height"] = "130";
    Defaults["Rx"] = "0";
    Defaults["Ry"] = "1";
})(Defaults || (Defaults = {}));

class NgxContentLoadingComponent {
    constructor() {
        this.width = Defaults.Width;
        this.height = Defaults.Height;
        this.primaryColor = Defaults.PrimaryColor;
        this.secondaryColor = Defaults.SecondaryColor;
        this.speed = Defaults.Speed;
        this.preserveAspectRatio = Defaults.PreserveAspectRatio;
    }
    get viewBox() {
        return `0 0 ${this.width} ${this.height}`;
    }
}
NgxContentLoadingComponent.ɵfac = function NgxContentLoadingComponent_Factory(t) { return new (t || NgxContentLoadingComponent)(); };
NgxContentLoadingComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxContentLoadingComponent, selectors: [["ngx-content-loading"]], inputs: { width: "width", height: "height", primaryColor: "primaryColor", secondaryColor: "secondaryColor", speed: "speed", preserveAspectRatio: "preserveAspectRatio" }, ngContentSelectors: _c1, decls: 4, vars: 2, template: function NgxContentLoadingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg");
        ɵngcc0.ɵɵprojection(2, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(3, 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("preserveAspectRatio", ctx.preserveAspectRatio)("viewBox", ctx.viewBox);
    } }, changeDetection: 0 });
NgxContentLoadingComponent.propDecorators = {
    width: [{ type: Input }],
    height: [{ type: Input }],
    primaryColor: [{ type: Input }],
    secondaryColor: [{ type: Input }],
    speed: [{ type: Input }],
    preserveAspectRatio: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxContentLoadingComponent, [{
        type: Component,
        args: [{ selector: 'ngx-content-loading', template: "<ng-content select=\"[before-svg]\"></ng-content>\n\n<svg\n    [attr.preserveAspectRatio]=\"preserveAspectRatio\"\n    [attr.viewBox]=\"viewBox\">\n        <ng-content></ng-content>\n</svg>\n\n<ng-content select=\"[after-svg]\"></ng-content>\n", changeDetection: ChangeDetectionStrategy.OnPush }]
    }], function () { return []; }, { width: [{
            type: Input
        }], height: [{
            type: Input
        }], primaryColor: [{
            type: Input
        }], secondaryColor: [{
            type: Input
        }], speed: [{
            type: Input
        }], preserveAspectRatio: [{
            type: Input
        }] }); })();

class SvgElementComponent {
    constructor(content) {
        this.content = content;
        this.clipPathId = getId();
        this.linearGradientId = getId();
    }
    get clipPathUrl() {
        return `url(#${this.clipPathId})`;
    }
    get linearGradientUrl() {
        return `url(#${this.linearGradientId})`;
    }
}
SvgElementComponent.ɵfac = function SvgElementComponent_Factory(t) { return new (t || SvgElementComponent)(ɵngcc0.ɵɵdirectiveInject(NgxContentLoadingComponent)); };
SvgElementComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SvgElementComponent, selectors: [["ngx-svg-element"]], decls: 0, vars: 0, template: function SvgElementComponent_Template(rf, ctx) { }, changeDetection: 0 });
SvgElementComponent.ctorParameters = () => [
    { type: NgxContentLoadingComponent }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgElementComponent, [{
        type: Component,
        args: [{ selector: 'ngx-svg-element', template: "", changeDetection: ChangeDetectionStrategy.OnPush }]
    }], function () { return [{ type: NgxContentLoadingComponent }]; }, null); })();
function getId() {
    const id = performance.now() * Math.random();
    return id.toString();
}

class RectComponent extends SvgElementComponent {
    constructor(content) {
        super(content);
        this.content = content;
        this.rx = Defaults.Rx;
        this.ry = Defaults.Ry;
    }
}
RectComponent.ɵfac = function RectComponent_Factory(t) { return new (t || RectComponent)(ɵngcc0.ɵɵdirectiveInject(NgxContentLoadingComponent)); };
RectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RectComponent, selectors: [["", "ngx-rect", ""]], inputs: { rx: "rx", ry: "ry", y: "y", x: "x", width: "width", height: "height", primaryColor: "primaryColor", secondaryColor: "secondaryColor", speed: "speed" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c2, decls: 7, vars: 22, consts: [["ngx-svg-stop", "", 3, "offset", "values", "speed", "color"]], template: function RectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(0, "rect");
        ɵngcc0.ɵɵelementStart(1, "defs");
        ɵngcc0.ɵɵelement(2, "clipPath");
        ɵngcc0.ɵɵelementStart(3, "linearGradient");
        ɵngcc0.ɵɵelement(4, "stop", 0)(5, "stop", 0)(6, "stop", 0);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("x", ctx.x)("y", ctx.y)("rx", ctx.rx)("ry", ctx.ry)("width", ctx.width)("fill", ctx.linearGradientUrl)("clipPath", ctx.clipPathUrl)("height", ctx.height);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.clipPathId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("id", ctx.linearGradientId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("offset", "0%")("values", "-2; 1")("speed", ctx.content.speed)("color", ctx.content.primaryColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("offset", "50%")("values", "-1.5; 1.5")("speed", ctx.content.speed)("color", ctx.content.secondaryColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("offset", "100%")("values", "-1; 2")("speed", ctx.content.speed)("color", ctx.content.primaryColor);
    } }, dependencies: function () { return [SvgStopComponent]; } });
RectComponent.ctorParameters = () => [
    { type: NgxContentLoadingComponent }
];
RectComponent.propDecorators = {
    y: [{ type: Input }],
    x: [{ type: Input }],
    rx: [{ type: Input }],
    ry: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    primaryColor: [{ type: Input }],
    secondaryColor: [{ type: Input }],
    speed: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RectComponent, [{
        type: Component,
        args: [{ selector: '[ngx-rect]', template: "<svg:rect\n        [attr.x]=\"x\"\n        [attr.y]=\"y\"\n        [attr.rx]=\"rx\"\n        [attr.ry]=\"ry\"\n        [attr.width]=\"width\"\n        [attr.fill]=\"linearGradientUrl\"\n        [attr.clipPath]=\"clipPathUrl\"\n        [attr.height]=\"height\">\n</svg:rect>\n\n<svg:defs>\n    <svg:clipPath [attr.id]=\"clipPathId\"></svg:clipPath>\n\n    <svg:linearGradient [attr.id]=\"linearGradientId\">\n        <svg:stop ngx-svg-stop\n            [offset]=\"'0%'\"\n            [values]=\"'-2; 1'\"\n            [speed]=\"content.speed\"\n            [color]=\"content.primaryColor\">\n        </svg:stop>\n\n        <svg:stop ngx-svg-stop\n            [offset]=\"'50%'\"\n            [values]=\"'-1.5; 1.5'\"\n            [speed]=\"content.speed\"\n            [color]=\"content.secondaryColor\">\n        </svg:stop>\n\n        <svg:stop ngx-svg-stop\n            [offset]=\"'100%'\"\n            [values]=\"'-1; 2'\"\n            [speed]=\"content.speed\"\n            [color]=\"content.primaryColor\">\n        </svg:stop>\n    </svg:linearGradient>\n</svg:defs>\n" }]
    }], function () { return [{ type: NgxContentLoadingComponent }]; }, { rx: [{
            type: Input
        }], ry: [{
            type: Input
        }], y: [{
            type: Input
        }], x: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], primaryColor: [{
            type: Input
        }], secondaryColor: [{
            type: Input
        }], speed: [{
            type: Input
        }] }); })();

class SvgStopComponent {
}
SvgStopComponent.ɵfac = function SvgStopComponent_Factory(t) { return new (t || SvgStopComponent)(); };
SvgStopComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SvgStopComponent, selectors: [["", "ngx-svg-stop", ""]], hostVars: 2, hostBindings: function SvgStopComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("offset", ctx.offset)("stop-color", ctx.color);
    } }, inputs: { speed: "speed", values: "values", opacity: "opacity", offset: "offset", color: "color" }, attrs: _c3, decls: 1, vars: 3, consts: [["attributeName", "offset", "repeatCount", "indefinite"]], template: function SvgStopComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(0, "animate", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("values", ctx.values)("dur", ctx.speed)("opacity", ctx.opacity);
    } }, changeDetection: 0 });
SvgStopComponent.propDecorators = {
    speed: [{ type: Input }],
    values: [{ type: Input }],
    opacity: [{ type: Input }],
    offset: [{ type: HostBinding, args: ['attr.offset',] }, { type: Input }],
    color: [{ type: HostBinding, args: ['attr.stop-color',] }, { type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgStopComponent, [{
        type: Component,
        args: [{ selector: '[ngx-svg-stop]', template: "<svg:animate\n    attributeName=\"offset\"\n    [attr.values]=\"values\"\n    [attr.dur]=\"speed\"\n    [attr.opacity]=\"opacity\"\n    repeatCount=\"indefinite\"\n/>\n", changeDetection: ChangeDetectionStrategy.OnPush }]
    }], null, { speed: [{
            type: Input
        }], values: [{
            type: Input
        }], opacity: [{
            type: Input
        }], offset: [{
            type: HostBinding,
            args: ['attr.offset']
        }, {
            type: Input
        }], color: [{
            type: HostBinding,
            args: ['attr.stop-color']
        }, {
            type: Input
        }] }); })();

class FacebookPresetComponent {
}
FacebookPresetComponent.ɵfac = function FacebookPresetComponent_Factory(t) { return new (t || FacebookPresetComponent)(); };
FacebookPresetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FacebookPresetComponent, selectors: [["", "ngx-facebook-preset", ""]], attrs: _c4, decls: 6, vars: 0, consts: [["ngx-circle", "", "cx", "25", "cy", "25", "r", "25"], ["ngx-rect", "", "width", "100", "height", "5", "y", "15", "x", "60", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "60", "height", "5", "y", "30", "x", "60", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "170", "height", "5", "y", "65", "x", "0", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "220", "height", "5", "y", "80", "x", "0", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "130", "height", "5", "y", "95", "x", "0", "rx", "5", "ry", "5"]], template: function FacebookPresetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(0, "g", 0)(1, "g", 1)(2, "g", 2)(3, "g", 3)(4, "g", 4)(5, "g", 5);
    } }, dependencies: function () { return [RectComponent, CircleComponent]; }, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FacebookPresetComponent, [{
        type: Component,
        args: [{ selector: '[ngx-facebook-preset]', template: "<svg:g ngx-circle cx=\"25\" cy=\"25\" r=\"25\"></svg:g>\n<svg:g ngx-rect width=\"100\" height=\"5\" y=\"15\" x=\"60\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"60\" height=\"5\" y=\"30\" x=\"60\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"170\" height=\"5\" y=\"65\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"220\" height=\"5\" y=\"80\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"130\" height=\"5\" y=\"95\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n", changeDetection: ChangeDetectionStrategy.OnPush }]
    }], null, null); })();

class InstagramPresetComponent {
}
InstagramPresetComponent.ɵfac = function InstagramPresetComponent_Factory(t) { return new (t || InstagramPresetComponent)(); };
InstagramPresetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InstagramPresetComponent, selectors: [["", "ngx-instagram-preset", ""]], attrs: _c5, decls: 4, vars: 0, consts: [["ngx-circle", "", "cx", "25", "cy", "25", "r", "25"], ["ngx-rect", "", "width", "120", "height", "10", "y", "10", "x", "60", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "40", "height", "5", "y", "30", "x", "60", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "250", "height", "250", "y", "60", "x", "0", "rx", "5", "ry", "5"]], template: function InstagramPresetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(0, "g", 0)(1, "g", 1)(2, "g", 2)(3, "g", 3);
    } }, dependencies: function () { return [RectComponent, CircleComponent]; }, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InstagramPresetComponent, [{
        type: Component,
        args: [{ selector: '[ngx-instagram-preset]', template: "<svg:g ngx-circle cx=\"25\" cy=\"25\" r=\"25\"></svg:g>\n<svg:g ngx-rect width=\"120\" height=\"10\" y=\"10\" x=\"60\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"40\" height=\"5\" y=\"30\" x=\"60\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"250\" height=\"250\" y=\"60\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n", changeDetection: ChangeDetectionStrategy.OnPush }]
    }], null, null); })();

class CircleComponent extends SvgElementComponent {
    constructor(content) {
        super(content);
        this.content = content;
    }
}
CircleComponent.ɵfac = function CircleComponent_Factory(t) { return new (t || CircleComponent)(ɵngcc0.ɵɵdirectiveInject(NgxContentLoadingComponent)); };
CircleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CircleComponent, selectors: [["", "ngx-circle", ""]], inputs: { r: "r", cx: "cx", cy: "cy" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c6, decls: 7, vars: 19, consts: [["ngx-svg-stop", "", 3, "offset", "values", "speed", "color"]], template: function CircleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(0, "circle");
        ɵngcc0.ɵɵelementStart(1, "defs");
        ɵngcc0.ɵɵelement(2, "clipPath");
        ɵngcc0.ɵɵelementStart(3, "linearGradient");
        ɵngcc0.ɵɵelement(4, "stop", 0)(5, "stop", 0)(6, "stop", 0);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("cx", ctx.cx)("cy", ctx.cy)("r", ctx.r)("fill", ctx.linearGradientUrl)("clipPath", ctx.clipPathUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.clipPathId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("id", ctx.linearGradientId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("offset", "0%")("values", "-2; 1")("speed", ctx.content.speed)("color", ctx.content.primaryColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("offset", "50%")("values", "-1.5; 1.5")("speed", ctx.content.speed)("color", ctx.content.secondaryColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("offset", "100%")("values", "-1; 2")("speed", ctx.content.speed)("color", ctx.content.primaryColor);
    } }, dependencies: [SvgStopComponent] });
CircleComponent.ctorParameters = () => [
    { type: NgxContentLoadingComponent }
];
CircleComponent.propDecorators = {
    r: [{ type: Input }],
    cx: [{ type: Input }],
    cy: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CircleComponent, [{
        type: Component,
        args: [{ selector: '[ngx-circle]', template: "<svg:circle\n        [attr.cx]=\"cx\"\n        [attr.cy]=\"cy\"\n        [attr.r]=\"r\"\n        [attr.fill]=\"linearGradientUrl\"\n        [attr.clipPath]=\"clipPathUrl\">\n</svg:circle>\n\n<svg:defs>\n    <svg:clipPath [attr.id]=\"clipPathId\"></svg:clipPath>\n\n    <svg:linearGradient [attr.id]=\"linearGradientId\">\n        <svg:stop ngx-svg-stop\n            [offset]=\"'0%'\"\n            [values]=\"'-2; 1'\"\n            [speed]=\"content.speed\"\n            [color]=\"content.primaryColor\">\n        </svg:stop>\n\n        <svg:stop ngx-svg-stop\n            [offset]=\"'50%'\"\n            [values]=\"'-1.5; 1.5'\"\n            [speed]=\"content.speed\"\n            [color]=\"content.secondaryColor\">\n        </svg:stop>\n\n        <svg:stop ngx-svg-stop\n            [offset]=\"'100%'\"\n            [values]=\"'-1; 2'\"\n            [speed]=\"content.speed\"\n            [color]=\"content.primaryColor\">\n        </svg:stop>\n    </svg:linearGradient>\n</svg:defs>\n" }]
    }], function () { return [{ type: NgxContentLoadingComponent }]; }, { r: [{
            type: Input
        }], cx: [{
            type: Input
        }], cy: [{
            type: Input
        }] }); })();

class CodePresetComponent {
    constructor() { }
    ngOnInit() {
    }
}
CodePresetComponent.ɵfac = function CodePresetComponent_Factory(t) { return new (t || CodePresetComponent)(); };
CodePresetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CodePresetComponent, selectors: [["", "ngx-code-preset", ""]], attrs: _c7, decls: 9, vars: 0, consts: [["ngx-rect", "", "width", "60", "height", "10", "y", "15", "x", "0", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "90", "height", "10", "y", "15", "x", "70", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "20", "height", "10", "y", "15", "x", "170", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "100", "height", "10", "y", "35", "x", "9", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "120", "height", "10", "y", "35", "x", "120", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "90", "height", "10", "y", "55", "x", "5", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "90", "height", "10", "y", "55", "x", "105", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "70", "height", "10", "y", "55", "x", "205", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "30", "height", "10", "y", "75", "x", "0", "rx", "5", "ry", "5"]], template: function CodePresetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(0, "g", 0)(1, "g", 1)(2, "g", 2)(3, "g", 3)(4, "g", 4)(5, "g", 5)(6, "g", 6)(7, "g", 7)(8, "g", 8);
    } }, dependencies: [RectComponent], encapsulation: 2, changeDetection: 0 });
CodePresetComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CodePresetComponent, [{
        type: Component,
        args: [{
                selector: '[ngx-code-preset]',
                template: "<svg:g ngx-rect width=\"60\" height=\"10\" y=\"15\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"90\" height=\"10\" y=\"15\" x=\"70\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"20\" height=\"10\" y=\"15\" x=\"170\" rx=\"5\" ry=\"5\"></svg:g>\n\n<svg:g ngx-rect width=\"100\" height=\"10\" y=\"35\" x=\"9\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"120\" height=\"10\" y=\"35\" x=\"120\" rx=\"5\" ry=\"5\"></svg:g>\n\n<svg:g ngx-rect width=\"90\" height=\"10\" y=\"55\" x=\"5\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"90\" height=\"10\" y=\"55\" x=\"105\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"70\" height=\"10\" y=\"55\" x=\"205\" rx=\"5\" ry=\"5\"></svg:g>\n\n<svg:g ngx-rect width=\"30\" height=\"10\" y=\"75\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, null); })();

class BulletListPresetComponent {
}
BulletListPresetComponent.ɵfac = function BulletListPresetComponent_Factory(t) { return new (t || BulletListPresetComponent)(); };
BulletListPresetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BulletListPresetComponent, selectors: [["", "ngx-bullet-list-preset", ""]], attrs: _c8, decls: 8, vars: 0, consts: [["ngx-circle", "", "cx", "7", "cy", "7", "r", "7"], ["ngx-circle", "", "cx", "7", "cy", "37", "r", "7"], ["ngx-circle", "", "cx", "7", "cy", "67", "r", "7"], ["ngx-circle", "", "cx", "7", "cy", "97", "r", "7"], ["ngx-rect", "", "width", "200", "height", "12", "y", "2", "x", "20", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "200", "height", "12", "y", "32", "x", "20", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "200", "height", "12", "y", "62", "x", "20", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "200", "height", "12", "y", "92", "x", "20", "rx", "5", "ry", "5"]], template: function BulletListPresetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(0, "g", 0)(1, "g", 1)(2, "g", 2)(3, "g", 3)(4, "g", 4)(5, "g", 5)(6, "g", 6)(7, "g", 7);
    } }, dependencies: [RectComponent, CircleComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BulletListPresetComponent, [{
        type: Component,
        args: [{
                selector: '[ngx-bullet-list-preset]',
                template: "<svg:g ngx-circle cx=\"7\" cy=\"7\" r=\"7\"></svg:g>\n<svg:g ngx-circle cx=\"7\" cy=\"37\" r=\"7\"></svg:g>\n<svg:g ngx-circle cx=\"7\" cy=\"67\" r=\"7\"></svg:g>\n<svg:g ngx-circle cx=\"7\" cy=\"97\" r=\"7\"></svg:g>\n\n<svg:g ngx-rect width=\"200\" height=\"12\" y=\"2\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"200\" height=\"12\" y=\"32\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"200\" height=\"12\" y=\"62\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"200\" height=\"12\" y=\"92\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, null); })();

class ListPresetComponent {
    constructor() { }
    ngOnInit() {
    }
}
ListPresetComponent.ɵfac = function ListPresetComponent_Factory(t) { return new (t || ListPresetComponent)(); };
ListPresetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ListPresetComponent, selectors: [["", "ngx-list-preset", ""]], attrs: _c9, decls: 6, vars: 0, consts: [["ngx-rect", "", "width", "200", "height", "10", "y", "0", "x", "0", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "180", "height", "10", "y", "20", "x", "20", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "160", "height", "10", "y", "40", "x", "20", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "200", "height", "10", "y", "60", "x", "0", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "180", "height", "10", "y", "80", "x", "20", "rx", "5", "ry", "5"], ["ngx-rect", "", "width", "60", "height", "10", "y", "100", "x", "20", "rx", "5", "ry", "5"]], template: function ListPresetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(0, "g", 0)(1, "g", 1)(2, "g", 2)(3, "g", 3)(4, "g", 4)(5, "g", 5);
    } }, dependencies: [RectComponent], encapsulation: 2, changeDetection: 0 });
ListPresetComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListPresetComponent, [{
        type: Component,
        args: [{
                selector: '[ngx-list-preset]',
                template: "<svg:g ngx-rect width=\"200\" height=\"10\" y=\"0\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"180\" height=\"10\" y=\"20\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"160\" height=\"10\" y=\"40\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"200\" height=\"10\" y=\"60\" x=\"0\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"180\" height=\"10\" y=\"80\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n<svg:g ngx-rect width=\"60\" height=\"10\" y=\"100\" x=\"20\" rx=\"5\" ry=\"5\"></svg:g>\n\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, null); })();

class NgxContentLoadingModule {
}
NgxContentLoadingModule.ɵfac = function NgxContentLoadingModule_Factory(t) { return new (t || NgxContentLoadingModule)(); };
NgxContentLoadingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxContentLoadingModule });
NgxContentLoadingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxContentLoadingModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    NgxContentLoadingComponent,
                    RectComponent,
                    CircleComponent,
                    SvgElementComponent,
                    SvgStopComponent,
                    FacebookPresetComponent,
                    InstagramPresetComponent,
                    CodePresetComponent,
                    BulletListPresetComponent,
                    ListPresetComponent
                ],
                exports: [
                    NgxContentLoadingComponent,
                    RectComponent,
                    CircleComponent,
                    FacebookPresetComponent,
                    InstagramPresetComponent,
                    CodePresetComponent,
                    BulletListPresetComponent,
                    ListPresetComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxContentLoadingModule, { declarations: function () { return [NgxContentLoadingComponent, RectComponent, CircleComponent, SvgElementComponent, SvgStopComponent, FacebookPresetComponent, InstagramPresetComponent, CodePresetComponent, BulletListPresetComponent, ListPresetComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxContentLoadingComponent, RectComponent, CircleComponent, FacebookPresetComponent, InstagramPresetComponent, CodePresetComponent, BulletListPresetComponent, ListPresetComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { NgxContentLoadingModule, NgxContentLoadingComponent as ɵa, RectComponent as ɵb, SvgElementComponent as ɵc, CircleComponent as ɵd, SvgStopComponent as ɵe, FacebookPresetComponent as ɵf, InstagramPresetComponent as ɵg, CodePresetComponent as ɵh, BulletListPresetComponent as ɵi, ListPresetComponent as ɵj };

